import React from 'react';
import { Star, CheckCircle2, ShieldCheck, Users, BookOpen } from 'lucide-react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative pt-12 pb-10 md:pt-32 md:pb-24 overflow-hidden mt-[-30px] mb-[-30px]" data-id="element-97">
      {/* Background decoration */}
      <div className="absolute inset-0 bg-gradient-to-br from-brand-50 to-white -z-10" data-id="element-98" />
      <div className="absolute top-0 right-0 -translate-y-12 translate-x-1/3 w-[800px] h-[800px] bg-brand-100/50 rounded-full blur-3xl -z-10" data-id="element-99" />

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-100">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-brand-100 text-brand-700 font-medium md:text-sm mb-6 md:mb-8 text-[14px]" data-id="element-101">
          ¿Y si el problema no eras vos, sino como estabas estudiando? Todo tu
          año de Contratos y Obligaciones Resuelto
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="text-3xl md:text-6xl font-extrabold tracking-tight text-slate-900 mb-4 md:mb-6 leading-tight" data-id="element-102">
          Megapack Método de Estudio <br className="hidden md:block" data-id="element-103" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-600 to-brand-400" data-id="element-104">
            Contratos y Obligaciones 6+6
          </span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="mx-auto mb-6 md:mb-8 w-full max-w-[716px]" data-id="element-105">
          <img src="https://cdn.magicpatterns.com/uploads/dWtPZJVmAnaxJiYDS9yvvV/MOCKUP.png" alt="Megapack Método de Estudio — Contratos y Obligaciones: 6 tomos, 6 bonus y el método de estudio que funciona" width={716} height={716} className="w-full h-auto rounded-2xl shadow-2xl shadow-slate-900/20" loading="eager" fetchPriority="high" decoding="async" data-id="element-106" />
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="text-lg md:text-2xl text-slate-600 mb-3 md:mb-4 font-medium" data-id="element-107">
          Tomos + Bonus
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="max-w-3xl mx-auto text-base md:text-lg text-slate-600 mb-8 md:mb-10 leading-relaxed" data-id="element-108">
          Tu parcial y oral de Contratos resueltos: teoría resumida, casos
          prácticos, artículos del CCCN y estrategia de examen.
          <span className="font-semibold text-slate-900" data-id="element-109">
            "Deja de estudiar lo que no entra. Empeza a estudiar lo que siempre
            preguntan"
          </span>
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10 md:mb-12" data-id="element-110">
          <a href="#pricing" className="w-full sm:w-auto px-6 py-4 md:px-8 md:py-4 bg-brand-600 hover:bg-brand-700 text-white rounded-xl font-bold text-base md:text-lg shadow-lg shadow-brand-500/30 transition-all transform hover:-translate-y-1 hover:scale-105 active:scale-95 flex items-center justify-center gap-2" data-id="element-111">
            💥 QUIERO MI CONTRATOS RESUELTO AHORA
          </a>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.5
      }} className="flex flex-wrap items-center justify-center gap-4 md:gap-12 text-xs md:text-sm font-medium text-slate-600" data-id="element-112">
          <div className="flex items-center gap-1.5 md:gap-2" data-id="element-113">
            <BookOpen className="w-4 h-4 md:w-5 md:h-5 text-brand-500" data-id="element-114" />
            PDF Digital Acceso Inmediato
          </div>
          <div className="flex items-center gap-1.5 md:gap-2" data-id="element-115">
            <Users className="w-4 h-4 md:w-5 md:h-5 text-brand-500" data-id="element-116" />
            Estudiantes de Abogacía
          </div>
          <div className="flex items-center gap-1.5 md:gap-2" data-id="element-117">
            <ShieldCheck className="w-4 h-4 md:w-5 md:h-5 text-green-500" data-id="element-118" />
            Garantía 7 días
          </div>
          <div className="flex items-center gap-1.5 md:gap-2" data-id="element-119">
            <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-blue-500" data-id="element-120" />
            Pago seguro Mercado Pago
          </div>
        </motion.div>

        {/* Social Proof */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="mt-12 md:mt-16 pt-8 md:pt-10 border-t border-slate-200" data-id="element-121">
          <div className="flex flex-col items-center justify-center mb-6 md:mb-8" data-id="element-122">
            <div className="flex gap-1 mb-1 md:mb-2" data-id="element-123">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 md:w-6 md:h-6 fill-accent-500 text-accent-500" data-id="element-124" />)}
            </div>
            <p className="font-bold text-sm md:text-base text-slate-900" data-id="element-125">
              +500 Estudiantes • 4.9 Rating • Todo Argentina
            </p>
          </div>

          <div className="flex overflow-x-auto snap-x snap-mandatory pb-4 -mx-4 px-4 md:grid md:grid-cols-3 md:overflow-visible md:snap-none md:pb-0 md:mx-0 md:px-0 gap-4 md:gap-6 text-left hide-scrollbar" data-id="element-126">
            <TestimonialCard quote="Organicé toda la materia en un fin de semana. Ahora sé exactamente qué estudiar cada día y cuáles son los artículos que siempre entran en el parcial. Nunca más estudié de apuntes sueltos sin saber si estaba estudiando lo correcto." author="Valentina G." role="Estudiante de Abogacía UBA, Buenos Aires" data-id="element-127" />
            <TestimonialCard quote="Los casos prácticos resueltos cambiaron todo. Aprobé el parcial de Contratos con 8 después de haberlo recursado dos veces. Y el oral lo rendí con una seguridad que no había tenido nunca." author="Matías R." role="Estudiante de Derecho UNR, Rosario" data-id="element-128" />
            <TestimonialCard quote="Adapto el cronograma según cuántos días me quedan para el parcial en 5 minutos. Antes me pasaba horas subrayando el Lorenzetti sin saber si lo que leía era lo que el profe tomaba." author="Camila F." role="Estudiante de Abogacía UNC, Córdoba" data-id="element-129" />
          </div>
        </motion.div>
      </div>
    </section>;
}
function TestimonialCard({
  quote,
  author,
  role
}: {
  quote: string;
  author: string;
  role: string;
}) {
  return <div className="bg-white p-5 md:p-6 rounded-2xl shadow-sm border border-slate-100 flex flex-col h-full min-w-[280px] w-[85vw] md:w-auto md:min-w-0 snap-center transition-transform hover:-translate-y-1" data-id="element-130">
      <div className="flex gap-1 mb-3 md:mb-4" data-id="element-131">
        {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 md:w-4 md:h-4 fill-accent-500 text-accent-500" data-id="element-132" />)}
      </div>
      <p className="text-sm md:text-base text-slate-600 italic mb-4 md:mb-6 flex-grow" data-id="element-133">
        "{quote}"
      </p>
      <div data-id="element-134">
        <p className="font-bold text-sm md:text-base text-slate-900" data-id="element-135">
          {author}
        </p>
        <p className="text-xs md:text-sm text-slate-500" data-id="element-136">{role}</p>
      </div>
    </div>;
}